import getSmimeInfobarMessageFromErrorCode from './getSmimeInfobarMessageFromErrorCode';
import {
    InfoBarMessageRank,
    InfoBarMessageSource,
    InfoBarMessageViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import SmimeContext from '../store/schema/SmimeContext';
import SmimeErrorStateEnum from 'owa-smime-adapter/lib/store/schema/SmimeErrorStateEnum';

/**
 * Utility function that returns the infobar view state for
 * S/MIME encoding errors.
 */
export default function getSmimeEncodeErrorInfoBarMessage(
    key: string,
    errorCode: SmimeErrorStateEnum,
    context: SmimeContext
): InfoBarMessageViewState {
    return {
        key,
        messageParts: getSmimeInfobarMessageFromErrorCode(errorCode, context),
        rank: InfoBarMessageRank.Error,
        source: InfoBarMessageSource.Compose,
    };
}
